import * as React from "react";
import {Backdrop, CircularProgress, Typography} from "@mui/material";
import {Stack} from "@mui/system";

export default function LoadingScreen({children}) {
    return (
        <Backdrop
            sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
            open={true}
        >
            <Stack direction={"column"} alignItems={"center"} justifyContent={"center"} flex={1} spacing={1}>
                <Stack direction={"row"} spacing={1}>
                    <CircularProgress/>
                    <img width={120} src='/public/images/x2bim_white.png'/>
                </Stack>
                {children}
            </Stack>
        </Backdrop>
    )
}
